<p-button
  [label]="btnLabel"
  [severity]="'secondary'"
  [icon]="btnIcon"
  [disabled]="processing"
  (onClick)="this.displayFileBrowser = true"
  />

<p-dialog
  [header]="isReplaceMode ? 'Webseiten – Dokument ersetzen' : 'Webseiten auswählen'"
  [(visible)]="displayFileBrowser"
  [modal]="true"
  [closable]="true"
  [style]="{width: '60vw', minHeight: '60vh'}"
  i18n-header="@@website-dialog-header"
  >
  <div class="sp-search">
    <span class="p-input-icon-left">
      <input
        type="text"
        pInputText
        [(ngModel)]="urlInput"
        placeholder="https://"
        class="sp-search-input"
        />
    </span>
    <p-button
      (click)="this.addPageToSelectedPages(urlInput); urlInput = ''"
      [disabled]="!this.isValidUrl"
      >
      <i
        class="ri-add-line"
        aria-hidden="true"
      ></i>
      <span i18n="@@website-add-url">Adresse hinzufügen</span>
    </p-button>
  </div>
  <div class="row">
    <div class="col-6">
      <!-- Seitenliste -->
      <ul class="sp-items">
        <!-- [pTooltip]="page.title"
        tooltipPosition="right" -->
        @for (page of this.selectedPages; track page) {
          <li
            class="file"
            [class.active]="page === this._selectedPage"
            (click)="this.showLinksForpage(page)"
            >
            <i
              class="ri-pages-line"
              aria-hidden="true"
            ></i>
            <span class="sp-item-name">{{ page }}</span>
            <button
              class="sp-remove-btn"
              (click)="this.removePageFromSelectedPages(page); $event.stopPropagation()"
              i18n-title="@@website-remove-page"
              title="Seite entfernen"
              >
              <i
                class="ri-close-line"
                aria-hidden="true"
              ></i>
            </button>
          </li>
        }

        <!-- Leer-Zustand -->
        @if (this.selectedPages.length === 0) {
          <li
            class="sp-empty"
            >
            <i
              class="ri-inbox-line"
              aria-hidden="true"
            ></i>
            <span i18n="@@website-empty-pages">Keine Seiten ausgewählt</span>
          </li>
        }
      </ul>

    </div>
    <div class="col-6">
      <!-- Suchfeld Web-Seiten -->
      <div class="sp-search">
        <span class="p-input-icon-left">

          <input
            type="text"
            pInputText
            [(ngModel)]="linkSearchQuery"
            placeholder="Verlinkungen filtern..."
            i18n-placeholder="@@website-search-pages"
            class="sp-search-input"
            />
        </span>
      </div>

      <!-- Loading -->
      @if (loading) {
        <div
          class="sp-loading"
          >
          <p-progressSpinner
            [style]="{width: '2.5rem', height: '2.5rem'}"
            strokeWidth="4"
            />
        </div>
      }

      <!-- Seitenliste -->
      @if (!loading) {
        <ul
          class="sp-items"
          >
          <!-- [pTooltip]="page.title"
          tooltipPosition="right" -->
          @for (page of this.filterdLinks; track page) {
            <li
              (click)="this.addPageToSelectedPages(page)"
              class="file"
              >
              <i
                class="ri-pages-line"
                aria-hidden="true"
              ></i>
              <span class="sp-item-name">{{ page }}</span>
            </li>
          }
          <!-- Leer-Zustand -->
          @if (this.filterdLinks.length === 0) {
            <li
              class="sp-empty"
              >
              <i
                class="ri-inbox-line"
                aria-hidden="true"
              ></i>
              <span i18n="@@website-empty-links">Keine Links gefunden</span>
            </li>
          }
        </ul>
      }
    </div>
  </div>

  <ng-template pTemplate="footer">
    <p-button
      [label]="'Abbrechen'"
      i18n-label="@@website-cancel"
      [severity]="'secondary'"
      [outlined]="true"
      (onClick)="this.cancel()"
      />
    <p-button
      [label]="'Übernehmen'"
      i18n-label="@@website-submit"
      [disabled]="this.selectedPages.length === 0 || this.processing"
      (onClick)="this.submit()"
      />
  </ng-template>
</p-dialog>